export default "__VITE_ASSET__DO0GlS6I__"